<div class="dialog-box card">
  <div class="card-header">
    {{
      contactType === "jc"
        ? "Report Recipients"
        : siteData?.company_name
          ? "Site Contacts"
          : "Client Contacts"
    }}

    @if (siteData?.company_name || clientData?.company_name) {
      <span>
        for
        <span class="fw-semibold">{{
          siteData?.company_name || clientData?.company_name
        }}</span>
      </span>
    }
    <span class="float-end ms-2" (click)="onCloseDialogue()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  <div>
    <div class="mb-4">
      <gtapp-auto-complete
        [data]="contactLookupList"
        placeHolder="Recipient"
        searchKeyword="user_full_name"
        [itemTemplate]="reportRecipientLookupTemplate"
        [addInitialKey]="true"
        (inputChanged)="contactLookup($event)"
        (selected)="addContactToSelected($event)"
      >
      </gtapp-auto-complete>
      <ng-template #reportRecipientLookupTemplate let-user>
        @if (user?.key === 0) {
          <div>Add Recipient</div>
        } @else {
          <div>
            {{ user?.user_full_name }}
            @if (user?.location_contact_id) {
              <div text="Onsite Contact" class="badge"></div>
            }
            <div>
              <small>
                {{ user?.user_full_name ? user.user_email : "" }}
                {{
                  user?.user_mobile_number
                    ? " , " + user?.user_mobile_number
                    : ""
                }}
              </small>
            </div>
          </div>
        }
      </ng-template>
    </div>

    <div class="row row-cols-1 row-cols-lg-2 row-cols-xxl-3 mb-4">
      @if (clientContactList?.length > 1) {
        <div class="col-12 col-lg-12 col-xxl-12 text-primary form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="selectedUsers?.length === clientContactList?.length"
            (change)="selectAllContactReportRecipients($event)"
            id="selectAllBox"
          />
          <label for="selectAllBox"
            >Select All [{{ clientContactList?.length }}]</label
          >
        </div>
      }
      @for (contact of clientContactList; track contact; let i = $index) {
        <div class="col form-check" (click)="addRemoveContact(contact)">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="contact?.selected"
            id="check-{{ contact.id }}-{{ i }}"
          />
          <label class="form-check-label" for="check-{{ contact.id }}-{{ i }}">
            {{ contact?.user_full_name || contact?.full_name }}
            @if (contact?.is_site_contact) {
              <span class="small-font text-secondary">[Site Contact]</span>
            }
            <div class="small-font">
              {{ contact?.user_email || contact?.email }}
              {{
                contact?.user_mobile_number
                  ? " , " + contact?.user_mobile_number
                  : ""
              }}
            </div>
          </label>
        </div>
      }
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button (click)="onCloseDialogue()" class="btn btn-dark btn-lg w-100">
          Cancel
        </button>
      </div>
      <div class="col">
        <button class="btn btn-primary btn-lg w-100" (click)="addRemoveUsers()">
          Update
        </button>
      </div>
    </div>
  </div>
</div>
